<ng-container *transloco="let t">
  <div [formGroup]="form" class="owner-statement-inpatient-admission">
    <h3 class="mb-2">
      {{ t('Form for Admission to Inpatient Treatment - Inpatient') }}
    </h3>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t('Animal is admitted for inpatient treatment for:')
      }}</mat-label>
      <textarea matInput formControlName="admissionReason" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('Previous preventive procedures:') }}</mat-label>
      <textarea
        matInput
        formControlName="preventiveActions"
        rows="4"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t('External parasite treatment (product and date of last treatment):')
      }}</mat-label>
      <textarea
        matInput
        formControlName="externalParasites"
        rows="4"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t('Internal parasite treatment (product and date of last treatment):')
      }}</mat-label>
      <textarea
        matInput
        formControlName="internalParasites"
        rows="4"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t('Heartworm treatment (product and date of last treatment):')
      }}</mat-label>
      <textarea
        matInput
        formControlName="heartwormTreatment"
        rows="4"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t(
          'Vaccines against infectious diseases (vaccine and date of last application):'
        )
      }}</mat-label>
      <textarea
        matInput
        formControlName="infectiousVaccines"
        rows="4"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t('Vaccine against rabies (vaccine and date of last application):')
      }}</mat-label>
      <textarea matInput formControlName="rabiesVaccine" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-4">
      <mat-label>{{ t("History of the animal's disease:") }}</mat-label>
      <textarea matInput formControlName="medicalHistory" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t(
          'I agree to pay the pre-agreed financial obligations in the amount of'
        )
      }}</mat-label>
      <input matInput formControlName="agreedPrepaidAmount" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t(
          'I agree that if necessary I will pay additional funds up to the maximum amount of'
        )
      }}</mat-label>
      <input matInput formControlName="agreedAdditionalAmount" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{
        t('I commit to leaving a deposit in the amount of')
      }}</mat-label>
      <input matInput formControlName="depositAmount" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
